<template>
	<el-card>
		<el-row class="risk__title">退款风控配置</el-row>
		<!-- 分组搜索 -->
		<el-row class="risk__search">
			<span>分组名称：</span>
			<el-input v-model="groupQuery.riskName" placeholder="请输入分组名称" style="width: 220px" clearable />
			<span>状态：</span>
			<el-select v-model="groupQuery.valid" placeholder="全部" clearable style="width: 120px">
				<el-option :value="null" label="全部" />
				<el-option :value="1" label="启用" />
				<el-option :value="0" label="禁用" />
			</el-select>
			<el-button type="primary" style="margin-left: 20px" @click="fetchGroupList(1)">搜索</el-button>
		</el-row>
		<!-- 分组列表 -->
		<el-row>
			<el-table border :data="groupTable">
				<el-table-column prop="id" label="ID" align="center" width="80" />
				<el-table-column prop="riskName" label="分组名称" align="center" />
				<el-table-column prop="channel" label="渠道" align="center" />
				<el-table-column prop="riskDesc" label="描述" align="center" />
				<el-table-column label="状态" align="center" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.valid == 1 ? 'success' : 'info'">{{ scope.row.valid == 1 ? '启用' : '禁用'
						}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="operator" label="操作人" align="center" width="120" />
				<el-table-column prop="mtime" label="更新时间" align="center" :formatter="formatSecondTs" width="180" />
				<el-table-column label="操作" align="center" width="220">
					<template slot-scope="scope">
						<el-button type="text" @click="viewItems(scope.row)">查看</el-button>
						<el-button type="text" @click="toggleGroupValid(scope.row)">{{ scope.row.valid == 1 ? '禁用' :
							'启用' }}</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<el-pagination background layout="prev, pager, next" :total="groupTotal" :page-size="30"
			@current-change="handleGroupPageChange" />

		<el-divider />

		<!-- 配置项列表（根据当前选中的分组） -->
		<el-row class="risk__subTitle">
			<span>配置项列表</span>
			<span v-if="currentGroup.id" style="margin-left: 10px; color: #999">当前分组：{{ currentGroup.riskName }} (ID: {{
				currentGroup.id }})</span>
		</el-row>
		<!-- 配置项搜索（标签名称） -->
		<el-row class="risk__search">
			<span>标签名称：</span>
			<el-input v-model="itemQuery.name" placeholder="请输入标签名称" style="width: 220px" clearable />
			<el-button type="primary" style="margin-left: 20px" @click="fetchItemList(1)">搜索</el-button>
		</el-row>
		<el-row>
			<el-table border :data="itemTable">
				<el-table-column prop="id" label="ID" align="center" width="80" />
				<el-table-column prop="name" label="名称" align="center" />
				<el-table-column prop="riskSign" label="风控标签" align="center" width="100" />
				<el-table-column prop="riskScore" label="风险系数" align="center" width="100" >
					<template slot-scope="scope">
						<el-tag :type="scope.row.riskScore == 0.1 ? 'success' : scope.row.riskScore == 0.3 ? 'warning' : 'danger'">{{ scope.row.riskScore == 0.1 ? '低' : scope.row.riskScore == 0.3 ? '中' : '高'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="triggerType" label="触发类型" align="center" width="100" :formatter="triggerTypeText"/>
				<el-table-column prop="userGroup" label="用户类型" align="center" width="120">
					<template slot-scope="scope">{{ userGroupText(scope.row.userGroup) }}</template>
				</el-table-column>
				<el-table-column prop="monitorText" label="预警文案" align="center" />
				<el-table-column label="状态" align="center" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.valid == 1 ? 'success' : 'info'">{{ scope.row.valid == 1 ? '启用' : '禁用'
						}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="mtime" label="更新时间" align="center" :formatter="formatSecondTs" width="180" />
				<el-table-column label="操作" align="center" width="220">
					<template slot-scope="scope">
						<el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
						<el-button type="text" @click="toggleItemValid(scope.row)">{{ scope.row.valid == 1 ? '禁用' : '启用'
						}}</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-row>
		<el-pagination background layout="prev, pager, next" :total="itemTotal" :page-size="30"
			@current-change="handleItemPageChange" />

		<!-- 编辑弹窗（配置项） -->
		<el-dialog :visible.sync="editVisible" title="编辑配置项" width="600px" @close="resetEdit">
			<el-form :model="editForm" label-width="120px">
				<el-form-item label="风险系数">
					<el-select v-model="editForm.riskScore" placeholder="请选择" style="width: 100%">
						<el-option :value="'0.1'" label="低 - 0.1" />
						<el-option :value="'0.3'" label="中 - 0.3" />
						<el-option :value="'0.5'" label="高 - 0.5" />
					</el-select>
				</el-form-item>
				<el-form-item label="用户类型">
					<el-select v-model="editForm.userGroup" placeholder="请选择" style="width: 100%">
						<template v-if="userGroupOptions && userGroupOptions.length">
							<el-option v-for="opt in userGroupOptions" :key="opt.value" :value="opt.value"
								:label="opt.name" />
						</template>
						<template v-else>
							<el-option :value="0" label="所有用户" />
							<el-option :value="1" label="新用户" />
							<el-option :value="2" label="老用户" />
						</template>
					</el-select>
				</el-form-item>
				<el-form-item label="是否启用">
					<el-switch v-model="editForm.valid" :active-value="1" :inactive-value="0" />
				</el-form-item>
				<template v-if="currentConfigSchema.length">
					<el-form-item v-for="field in currentConfigSchema" :key="field.key || field.label"
						:label="field.label">
						<el-select v-if="field.type === 'select' && field.optionsKey === 'cycleOptions'"
							v-model="editForm.config[field.key]" placeholder="请选择" style="width: 100%" :disabled="field.disabled === true">
							<el-option v-for="opt in cycleOptions" :key="opt.value" :value="opt.value"
								:label="opt.name" />
						</el-select>
						<template v-else-if="field.type === 'group'">
							<div class="inline-group">
								<div class="inline-item" v-for="child in field.children" :key="child.key">
									<el-input v-if="child.type !== 'number'" v-model="editForm.config[child.key]"
										:placeholder="child.placeholder || '请输入'" />
									<el-input v-else v-model.number="editForm.config[child.key]"
										:placeholder="child.placeholder || '请输入'" />
									<div class="inline-hint" v-if="child.hint">{{ child.hint }}</div>
								</div>
							</div>
						</template>
						<el-tag v-else-if="field.type === 'fixed'" effect="plain">{{ field.display || field.value
						}}</el-tag>
						<el-input v-else-if="field.type === 'number'" v-model.number="editForm.config[field.key]"
							:placeholder="field.placeholder || '请输入'" />
						<el-input v-else v-model="editForm.config[field.key]" placeholder="请输入" />
					</el-form-item>
				</template>
				<template v-else>
					<el-form-item v-for="(label, key) in defaultFieldLabelMapToShow" :key="key" :label="label">
						<el-input v-model="editForm.config[key]" placeholder="请输入" />
					</el-form-item>
				</template>
				<el-form-item label="预警文案">
					<el-input v-model="editForm.monitorText" placeholder="如：%s周期%s充值>=%s$" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitEdit">保 存</el-button>
			</span>
		</el-dialog>
	</el-card>
</template>

<script>
export default {
	data() {
		return {
			groupQuery: {
				riskName: '',
				valid: null,
				page: 1,
			},
			groupTable: [],
			groupTotal: 0,
			itemQuery: {
				parentId: null,
				name: '',
				page: 1,
			},
			triggerType: [],
			itemTable: [],
			itemTotal: 0,
			currentGroup: {},
			editVisible: false,
			editForm: {
				id: null,
				riskScore: '',
				userGroup: 0,
				valid: 1,
				config: {},
				monitorText: '',
				riskSign: null,
			},
			userGroupOptions: [],
			cycleOptions: [],
			schemaByRiskSign: {
				1: [
					{ key: 'cycle', label: '周期', type: 'select', optionsKey: 'cycleOptions' },
					{ type: 'number', label: '线上充值;触发用户数;大于等于', key: 'number' }
				],
				2: [
					{ key: 'cycle', label: '周期', type: 'select', optionsKey: 'cycleOptions' },
					{ key: 'dollar', label: '线上充值;充值金额;大于等于', type: 'text' },
				],
				3: [
					{ key: 'cycle', label: '周期', type: 'select', optionsKey: 'cycleOptions' },
					{ key: 'interval', label: '充值间隔；小于等于（单位分钟）', type: 'number' },
					{ key: 'value', label: '线上充值;充值金额;小于等于', type: 'number' },
					{ key: 'times', label: '充值次数；大于等于', type: 'number' },
				],
				4: [
					{ key: 'cycle', label: '周期', type: 'select', optionsKey: 'cycleOptions' },
					{ key: 'ip', label: '线上充值；IP；等于', type: 'text' },
				],
				5: [
					{ key: 'cycle', label: '周期', type: 'select', optionsKey: 'cycleOptions', disabled: true, fixedValue: 8 },
					{ key: 'interval', label: '固定间隔', type: 'fixed', value: 30, display: '30 分钟' },
					{ key: 'percentage', label: '送礼金额占比(%)', type: 'number' },
				],
				6: [
					{ key: 'cycle', label: '周期', type: 'select', optionsKey: 'cycleOptions' },
					{ key: 'number', label: '同一城市退款触发用户数(>=)', type: 'number' },
				],
				7: [
					{ key: 'cycle', label: '周期', type: 'select', optionsKey: 'cycleOptions' },
					{ key: 'number', label: '退款触发用户数(>=)', type: 'number' },
				],
				8: [
					{ key: 'cycle', label: '周期', type: 'select', optionsKey: 'cycleOptions' },
					{ key: 'number', label: '退款收礼触发用户数(>=)', type: 'number' },
				],
				9: [
					{ key: 'cycle', label: '周期', type: 'select', optionsKey: 'cycleOptions' },
					{ key: 'gold', label: '线上充值收礼金币数(>=)', type: 'number' },
				],
				10: [
					{ key: 'cycle', label: '周期', type: 'select', optionsKey: 'cycleOptions', disabled: true, fixedValue: 8 },
					{ key: 'interval', label: '固定间隔', type: 'fixed', value: 60, display: '60 分钟' },
					{ key: 'gold', label: '收礼金币数(>=)', type: 'number' },
				],
				11: [
					{ key: 'cycle', label: '周期', type: 'select', optionsKey: 'cycleOptions' },
					{ key: 'number', label: '旗下退款用户数(>=)', type: 'number' },
				],
				12: [
					{ key: 'cycle', label: '周期', type: 'select', optionsKey: 'cycleOptions' },
					{ key: 'percentage', label: '旗下退款用户业绩占比(%)', type: 'number' },
				],
			},
			defaultFieldLabelMap: {
				cycle: '周期',
				interval: '间隔',
				value: '充值金额',
				times: '次数',
				number: '触发用户数',
				gold: '金币数',
				ip: '高危IP（逗号分隔）',
				percentage: '占比(%)',
				dollar: '金额($)',
			},
		}
	},
	computed: {
		currentConfigSchema() {
			const sign = this.editForm.riskSign
			if (!sign) return []
			return this.schemaByRiskSign[sign] || []
		},
		defaultFieldLabelMapToShow() {
			const map = {}
			const cfg = this.editForm.config || {}
			Object.keys(cfg).forEach((k) => {
				if (this.defaultFieldLabelMap[k]) map[k] = this.defaultFieldLabelMap[k]
			})
			return map
		},
	},
	mounted() {
		this.fetchGroupList(1)
		this.loadConstants()
	},
	methods: {
		triggerTypeText(row, column) {
			const v = row[column.property]
			if (!v && v !== 0) return ''
			return this.triggerType.find(item => item.value === v)?.name || ''
		},
		// 常量
		async fetchConstantDesc(className) {
			try {
				const { data: res } = await this.$axios({
					method: 'GET',
					withCredentials: true,
					url: (this.$store.getters.path && this.$store.getters.path.const_all) || '/host_admin/constant/desc/list',
					params: { username: this.$store.getters.username, token: this.$store.getters.token, className },
				})
				if (res && res.code === 0) return res.data || []
				this.$message.error((res && res.msg) || '常量获取失败')
				return []
			} catch (e) {
				return []
			}
		},
		async loadConstants() {
			const [userGroups, cycles, triggerTypes] = await Promise.all([
				this.fetchConstantDesc('com.quhong.constant.risk.RiskUserType'),
				this.fetchConstantDesc('com.quhong.constant.risk.RiskControlCycleConstant'),
				this.fetchConstantDesc('com.quhong.constant.risk.RiskControlTriggerType'),
			])
			this.userGroupOptions = Array.isArray(userGroups) ? userGroups : []
			this.cycleOptions = Array.isArray(cycles) ? cycles : []
			this.triggerType = Array.isArray(triggerTypes) ? triggerTypes : []
		},
		// 分组
		async fetchGroupList(page) {
			if (page) this.groupQuery.page = page
			const body = {
				riskName: this.groupQuery.riskName || undefined,
				valid: this.groupQuery.valid === null ? undefined : this.groupQuery.valid,
				page: this.groupQuery.page,
			}
			const { data: res } = await this.$axios({
				method: 'POST',
				withCredentials: true,
				headers: { 'Content-Type': 'application/json; charset=UTF-8' },
				url: this.$store.getters.path.risk_config_group_list,
				params: { username: this.$store.getters.username, token: this.$store.getters.token },
				data: body,
			})
			if (res.code !== 0) {
				this.$message.error(res.msg)
				return
			}
			this.groupTable = (res.data && res.data.data) || []
			this.groupTotal = (res.data && res.data.total) || 0
		},
		handleGroupPageChange(p) {
			this.fetchGroupList(p)
		},
		async toggleGroupValid(row) {
			const toValid = row.valid == 1 ? 0 : 1
			const { data: res } = await this.$axios({
				method: 'POST',
				withCredentials: true,
				headers: { 'Content-Type': 'application/json; charset=UTF-8' },
				url: this.$store.getters.path.risk_config_group_update_valid,
				params: { username: this.$store.getters.username, token: this.$store.getters.token },
				data: { id: row.id, toValid },
			})
			if (res.code !== 0) return this.$message.error(res.msg)
			this.$message.success('操作成功')
			this.fetchGroupList(this.groupQuery.page)
			if (this.currentGroup.id === row.id) {
				this.currentGroup.valid = toValid
			}
		},
		viewItems(group) {
			this.currentGroup = group
			this.itemQuery.parentId = group.id
			this.fetchItemList(1)
		},
		// 配置项
		async fetchItemList(page) {
			if (!this.itemQuery.parentId) return
			if (page) this.itemQuery.page = page
			const body = {
				parentId: this.itemQuery.parentId,
				name: this.itemQuery.name || undefined,
				page: this.itemQuery.page,
			}
			const { data: res } = await this.$axios({
				method: 'POST',
				withCredentials: true,
				headers: { 'Content-Type': 'application/json; charset=UTF-8' },
				url: this.$store.getters.path.risk_config_item_list,
				params: { username: this.$store.getters.username, token: this.$store.getters.token },
				data: body,
			})
			if (res.code !== 0) {
				this.$message.error(res.msg)
				return
			}
			this.itemTable = (res.data && res.data.data) || []
			this.itemTotal = (res.data && res.data.total) || 0
		},
		handleItemPageChange(p) {
			this.fetchItemList(p)
		},
		async toggleItemValid(row) {
			const toValid = row.valid == 1 ? 0 : 1
			const { data: res } = await this.$axios({
				method: 'POST',
				withCredentials: true,
				headers: { 'Content-Type': 'application/json; charset=UTF-8' },
				url: this.$store.getters.path.risk_config_item_update_valid,
				params: { username: this.$store.getters.username, token: this.$store.getters.token },
				data: { id: row.id, toValid },
			})
			if (res.code !== 0) return this.$message.error(res.msg)
			this.$message.success('操作成功')
			this.fetchItemList(this.itemQuery.page)
		},
		openEdit(row) {
			this.editForm.id = row.id
			this.editForm.riskScore = row.riskScore || ''
			this.editForm.userGroup = typeof row.userGroup === 'number' ? row.userGroup : 0
			this.editForm.valid = typeof row.valid === 'number' ? row.valid : 1
			this.editForm.riskSign = row.riskSign || null
			// riskJson 可能是字符串或对象
			try {
				const json = typeof row.riskJson === 'string' ? JSON.parse(row.riskJson || '{}') : (row.riskJson || {})
				this.editForm.config = json || {}
			} catch (e) {
				this.editForm.config = {}
			}
			this.editForm.monitorText = row.monitorText || ''
			this.editVisible = true
		},
		resetEdit() {
			this.editForm = { id: null, riskScore: '', userGroup: 0, valid: 1, config: {}, monitorText: '', riskSign: null }
		},
		async submitEdit() {
			if (!this.editForm.id) return this.$message.error('数据异常：缺少ID')
			let configObj = { ...(this.editForm.config || {}) }
			// 类型处理（按 schema 将数值型字段转为 number，空值剔除）
			const schema = this.schemaByRiskSign[this.editForm.riskSign] || []
			schema.forEach((f) => {
				if (f.type === 'fixed' && f.key) {
					configObj[f.key] = f.value
				}
				if (f.type === 'select' && f.disabled === true && typeof f.fixedValue !== 'undefined') {
					configObj[f.key] = f.fixedValue
				}
				if (configObj.hasOwnProperty(f.key)) {
					const v = configObj[f.key]
					if (v === '' || v === null || v === undefined) {
						delete configObj[f.key]
					} else if (f.type === 'number') {
						const num = Number(v)
						configObj[f.key] = isNaN(num) ? v : num
					}
				}
			})
			const payload = {
				id: this.editForm.id,
				riskScore: this.editForm.riskScore,
				userGroup: this.editForm.userGroup,
				valid: this.editForm.valid,
				config: configObj,
				monitorText: this.editForm.monitorText,
			}
			const { data: res } = await this.$axios({
				method: 'POST',
				withCredentials: true,
				headers: { 'Content-Type': 'application/json; charset=UTF-8' },
				url: this.$store.getters.path.risk_config_item_update_detail,
				params: { username: this.$store.getters.username, token: this.$store.getters.token },
				data: payload,
			})
			if (res.code !== 0) return this.$message.error(res.msg)
			this.$message.success('保存成功')
			this.editVisible = false
			this.fetchItemList(this.itemQuery.page)
		},
		formatSecondTs(row, column) {
			const v = row[column.property]
			if (!v && v !== 0) return ''
			const dt = new Date(v * 1000)
			const pad = (n) => (n < 10 ? '0' + n : '' + n)
			return (
				dt.getFullYear() +
				'-' + pad(dt.getMonth() + 1) +
				'-' + pad(dt.getDate()) +
				' ' + pad(dt.getHours()) +
				':' + pad(dt.getMinutes()) +
				':' + pad(dt.getSeconds())
			)
		},
		userGroupText(v) {
			if (v === 1) return '新用户'
			if (v === 2) return '老用户'
			return '所有用户'
		},
	},
}
</script>

<style scoped lang="scss">
.risk {
	&__title {
		font-size: 28px;
		font-weight: 700;
		margin-bottom: 20px;
	}

	&__subTitle {
		font-size: 20px;
		font-weight: 600;
		margin: 20px 0 10px;
	}

	&__search {
		span {
			font-size: 16px;
			font-weight: 600;
			margin-right: 10px;
			margin-left: 15px;
		}
	}
}
</style>
